import React, { useState } from "react";
import { DataGrid } from "Common/CusomReactGrid/CustomDataGrid";
import { useDispatch, useSelector } from "react-redux";
import { addPatient } from "Redux/TabsSlice/TabsSlice";
import NumberConversion from "Utils/NumberConversion";
import InsuranceErrorPopup from "Popups/InsuranceErrorPopup/InsuranceErrorPopup";
import ChangeClaimStatusPopup from "Popups/ChangeClaimStatusPopup/ChangeClaimStatusPopup";
import ConfirmationPopup from "Popups/ConfirmationPopup/ConfirmationPopup";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import api from "http";
import { toast } from "react-toastify";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import Dropdown from "Common/DropDown/Dropdown";
import FormatMomentDate from "Utils/FormatMomentDate";
import ThreeDotsIcon from "SVGS/ThreeDotsIcon";
import { Decryption } from "Utils/encryptionPassword";
import ViewItemizedReportPopup from "Popups/FinancialOverviewPopup/ViewItemizedReportPopup";
import { DELETED_SUCCESSFULLY } from "Common/ToastConstants";
import StatusPill from "Components/StatusPill/StatusPill";
import NewClaimStatusPopup from "Popups/NewClaimStatusPopup/NewClaimStatusPopup";
import Show from "Components/Show/Show";
import CreateWriteOffPopup from "Popups/CreateWriteOffPopup/CreateWriteOffPopup";
import { Tooltip } from "react-tooltip";



const ChargesSearchGrid = ({
  claimStatus,
  setClaim,
  getVisit = () => { },
  rows,
  paramModel,
  patientId,
  handlePerRowsChange,
  handlePageChange,
  handleRowSelection,
  selectedRows,
  selectColumn,
  parentName = ""
}) => {

  const [singleClaim, setSingleClaim] = useState(null);
  const [insErrPopup, setinsErrPopup] = useState(false);
  const [myRow, setMyRow] = useState({});
  const [change_ClaimStatus_Popup, setchange_ClaimStatus_Popup] = useState(false);
  const [claimDeleteConfirm, setClaimDeleteConfirm] = useState({ status: false, id: null })
  const [itemizedBillConfirm, setItemizedBillConfirm] = useState({
    confirmationPopupStatus: false,
    itemizedBillPopupStatus: false,
    url: "",
    patientId: "",
    visitId: ""
  })
  const [loader, setLoader] = useState(false)
  const [newClaimStatusChangePopup, setNewClaimStatusChangePopup] = useState(false)
  const [createWriteOffPopup, setCreateWriteOffPopup] = useState(false)
  const visitStatus = useSelector((state) => state.dataSlice.ClaimStatusCodes);

  const dispatch = useDispatch();

  const openClaimErrorPopup = (single_Claim) => {
    setSingleClaim(single_Claim);
    setinsErrPopup(true);
  };
  const closeClaimErrorPopup = () => {
    setSingleClaim(null);
    setinsErrPopup(false);
  };

  const openClaimStatusPopup = (row) => {
    setMyRow(row);
    setchange_ClaimStatus_Popup(true);
  };
  const closeClaimStatusPopup = () => {
    setchange_ClaimStatus_Popup(false);
    setMyRow({});
    getVisit();
  };

  const openNewClaimStatusChangePopup = (row) => {
    setNewClaimStatusChangePopup(true);
    setMyRow(row);
    getVisit();
  }
  const closeNewClaimStatusChangePopup = () => {
    setNewClaimStatusChangePopup(false);
    setMyRow({});
    getVisit();
  }

  const openCreateWriteOffPopup = (row) => {
    setCreateWriteOffPopup(true);
    setMyRow(row);
  }
  const closeCreateWriteOffPopup = () => {
    setCreateWriteOffPopup(false);
    setMyRow({});
    getVisit();
  }
  const confirmClaimDelete = async () => {
    try {
      setLoader(true);
      const payload = {
        "longList": [claimDeleteConfirm.id]
      }
      await api.post(`${process.env.REACT_APP_TC_PMS}/api/Visit/DeleteVisits`, payload)
      getVisit();
      toast.success(DELETED_SUCCESSFULLY)

    } catch (error) {
      for (const errr in error.response.data.dataModel) {
        toast.error(`VisitId:${error.response.data.dataModel[errr].visitId}: ${error.response.data.dataModel[errr].detail} `)
      }
      ErrorHandlingMessage(error)
    } finally {
      setClaimDeleteConfirm({
        status: false, id: null
      })
      setLoader(false);
    }
  }
  const openClaimDeleteConfirm = (row) => {
    setClaimDeleteConfirm({
      status: true, id: row.visitId
    })
  }
  const cancelClaimDelete = () => {
    setClaimDeleteConfirm({
      status: false, id: null
    })
  }
  const onConfirmItemizedBill = async () => {
    try {
      setLoader(true)
      const response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/Payment/FindPatientItemizedReport?patientId=${itemizedBillConfirm.patientId}&VisitId=${itemizedBillConfirm.visitId}`, {
        responseType: 'blob'
      });
      if (!response.data.isError) {
        const { presignedUrl } = response.data.dataModel;
        const decryptedUrl = Decryption(presignedUrl);
        setItemizedBillConfirm({
          itemizedBillPopupStatus: true,
          confirmationPopupStatus: false,
          url: decryptedUrl
        })
      } else {
        ErrorHandlingMessage(response.data.responseMessage);
      }
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoader(false);
    }
  }
  const openItemizedBillPopup = (row) => {
    setItemizedBillConfirm({
      confirmationPopupStatus: true,
      patientId: row.patientId,
      visitId: row.visitId
    })
  }
  const closeItemizedBillPopup = () => setItemizedBillConfirm({ confirmationPopupStatus: false, url: "", patientId: "", visitId: "", itemizedBillPopupStatus: false })

  const goToPatient = (row, tabname) => {
    const obj = {
      active: true,
      id: row.patientId,
      subTab: tabname,
      name: row.patientName,
      unsavedChanges: false,
      insuranceData: { status: false, editMode: false }
    };
    dispatch(addPatient(obj));
  };


  const columns = [
    {
      name: "Claim #",
      key: "id",
      disableFilters: true,
      // sortable: true,
      width: 90,

      formatter: ({ row }) => (
        <div className="flex items-center w-full h-full space-between">
          <span className={`pr-2 font-semibold ${parentName === "tasks" ? "text-gray-500 cursor-default" : "cursor-pointer hover:text-primary"} `} onClick={() => parentName !== "tasks" && setClaim(row)}  >
            {row.visitId}
          </span>
          {claimStatus === "ACK_277_D" && (
            // <RiErrorWarningFill title="Open claim Errors" onClick={() => openClaimErrorPopup(row)} size={16} className="ml-2 cursor-pointer text-primar" />
            <img src="/img/infored.svg" className="w-4 ml-auto mr-5 cursor-pointer text-primaryColor" alt="info" onClick={() => openClaimErrorPopup(row)} />
          )}
        </div>
      ),
    },
    {
      name: "Patient Name",
      key: "patientAccountNumber",

      formatter: ({ row }) => (
        <span>{row.patientName}</span>
      ),
    },
    // {
    //   name: "Account #", width: 80,
    //   key: "patientAccountNumber",
    // },
    {
      name: "DOS",
      width: 120,
      key: "dosFrom",
      formatter: ({ row }) => (
        <span>{FormatMomentDate(row.dosFrom)}</span>
      ),
    },
    {
      name: "Payer", key: "insurancePayerName", width: 240,
      renderCell: ({ row }) => {
        const tooltipContent = `${row.insurancePayerName ? `${row.insurancePayerName}\n` : ''}${row.secondaryInsurancePayerName ? `Secondary: ${row.secondaryInsurancePayerName}\n` : ''}`;        // const tooltipContent = `Primary: ${row.insurancePayerName || 'N/A'}\nSecondary: ${row.secondaryInsurancePayerName || 'N/A'}`;
        return (
          row.claimStatusCode !== "SP" && (row.insurancePayerName || row.secondaryInsurancePayerName) ? (
            <div className="inline-block w-full max-w-full pt-2 text-sm" data-tooltip-id="TasksClaimPayerTooltip"
              data-tooltip-content={tooltipContent} style={{ width: "auto", minWidth: 0 }}>
              <div className="flex flex-col">{row.insurancePayerName}
                <Show when={row.secondaryInsurancePayerName}>
                  <div className="inline-block text-xs text-secondaryLight">Secondary: {row.secondaryInsurancePayerName}</div>
                </Show></div>
            </div>) : (<span data-tooltip-id="TasksClaimPayerTooltip" data-tooltip-content="Self-Pay">Self-Pay</span>)
        )
      }
      // renderCell: ({ row }) => {
      //   return (
      //     <div className="pt-2 text-sm">
      //       Primary: {row.insurancePayerName}
      //       <div className="text-xs text-secondaryLight">Secondary: {row.secondaryInsurancePayerName}</div>
      //     </div>)
      // }
    },
    {
      name: "Claim Status",
      width: 175,
      key: "claimStatusCode",
      formatter: ({ row }) => {
        if (!row.claimStatusCode) return "";
        const statusInfo = visitStatus.find(
          (statusCode) => statusCode.statusCode === row.claimStatusCode
        );

        if (!statusInfo) return "";
        const statusDescription = statusInfo.statusDescription;
        if (row.claimStatusCode === "P") {
          return (
            <div className="mt-1">
              <div className={`status-pill  ${row.claimStatusCode === "P" && "status-pill-paid"}`}>
                {statusDescription}
              </div>
              {process.env.REACT_APP_DEVELOPMENT && <div className="text-xs text-secondaryLight">Responsible Party: {row.responsibleParty || "None"}</div>}
            </div>


          );
        }

        return <div className="mt-1">
          {statusDescription}
          {process.env.REACT_APP_DEVELOPMENT && <div className="text-xs text-secondaryLight">Responsible Party: {row.responsibleParty || "None"}</div>}
        </div>;
      },
    },
    {
      name: "Total Charge",
      key: "totalAmount",

      width: 100,
      formatter: ({ row }) => <span>{NumberConversion(row.totalAmount)}</span>,
    },
    {
      name: "Amount Due",
      key: "amountDue",

      width: 100,
      formatter: ({ row }) => {
        const amountDue = Number(row.amountDue) || 0;
        if (amountDue < 0) {
          return <StatusPill variant="failed">{NumberConversion(row.amountDue)}</StatusPill>;
        }
        return <span>{NumberConversion(row.amountDue)}</span>;
      },
    },

    {
      name: "Entry Date",
      key: "addedDate",
      width: 90,
      formatter: ({ row }) => (
        <span>{FormatMomentDate(row.addedDate)}</span>
      ),
    },
    {
      name: "Submitted Date",
      key: "submittedDate",
      width: 120,
      formatter: ({ row }) => (
        <span>{FormatMomentDate(row.submittedDate)}</span>
      ),
    },
    ...(parentName !== "tasks" ? [{
      name: "Action",
      key: "patientName",
      width: 80,
      minWidth: 80,
      maxWidth: 80,
      formatter: ({ row }) => {
        return (
          <div className='flex items-center justify-center h-full mr-5'>
            <Dropdown>
              <Dropdown.Button>
                <ThreeDotsIcon />
              </Dropdown.Button>
              <Dropdown.Menu>
                {!patientId && (
                  <>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={() => goToPatient(row, 'Overview')} >Overview </Dropdown.MenuItem>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={() => goToPatient(row, "Claims")} >Claims </Dropdown.MenuItem>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={() => goToPatient(row, "PatientPayments")}  >Patient Payments </Dropdown.MenuItem>
                  </>
                )}
                {/* {!row.isSelfPay && <Dropdown.MenuItem className="group rdx_item" onSelect={() => openClaimStatusPopup(row)}>Change Status </Dropdown.MenuItem>} */}
                {!row.isSelfPay && <Dropdown.MenuItem className="group rdx_item" onSelect={() => openNewClaimStatusChangePopup(row)}>Change Status </Dropdown.MenuItem>}
                {row.claimStatusCode === 'V' && <Dropdown.MenuItem className="group rdx_item" onSelect={() => openClaimDeleteConfirm(row)} > Delete Claim</Dropdown.MenuItem>}
                <Dropdown.MenuItem className="group rdx_item" onSelect={() => openItemizedBillPopup(row)} >
                  Itemized Bill
                </Dropdown.MenuItem>
                <Dropdown.MenuItem className="group rdx_item" onSelect={() => openCreateWriteOffPopup(row)} >
                  Create Write Off
                </Dropdown.MenuItem>


              </Dropdown.Menu>
            </Dropdown>
          </div>


          
        )
      }
      ,

    }] : []),
  ];
  // let bottomBarPosition = widthStatus[CLAIM_STATUS_OPTIONS_LIST.find(c => c.value === claimStatus).label]
  return (
    < >
      {loader && <FullPageLoader allowFullScreen />}
      {itemizedBillConfirm.itemizedBillPopupStatus && <ViewItemizedReportPopup onClose={closeItemizedBillPopup} url={itemizedBillConfirm.url} />}
      {itemizedBillConfirm.confirmationPopupStatus && <ConfirmationPopup cancelButtonTitle="No" buttonTitle="Yes" onCancel={closeItemizedBillPopup} onConfirm={onConfirmItemizedBill} subHeading="Are you sure you want to view Itemized Bill report?" />}
      <Tooltip id="TasksClaimPayerTooltip" style={{ zIndex: 9999, maxWidth: 300, whiteSpace: 'pre-line' }} />

      {insErrPopup && (
        <InsuranceErrorPopup
          onClose={closeClaimErrorPopup}
          row={singleClaim}
        />
      )}
      {change_ClaimStatus_Popup && (
        <ChangeClaimStatusPopup row={myRow} onClose={closeClaimStatusPopup} />
      )}
      {claimDeleteConfirm.status && <ConfirmationPopup
        onConfirm={confirmClaimDelete}
        onCancel={cancelClaimDelete}
        heading="Delete Claim"
        subHeading={"Are you sure you want to delete claim?"}
      />}
      <Show when={newClaimStatusChangePopup}>
        <NewClaimStatusPopup onClose={closeNewClaimStatusChangePopup} row={myRow} />
      </Show>

      <Show when={createWriteOffPopup}>
        <CreateWriteOffPopup onClose={closeCreateWriteOffPopup} row={myRow} />
      </Show>

      <DataGrid
        formId='chargesSearchForm'
        paginationDefaultPage={1}
        gridHeightOffset={320}
        columns={columns}
        rows={rows}
        pagination={{
          perPage: paramModel.perPage,
          pageNo: paramModel.pageNo,
          totalCount: paramModel.totalCount,
        }}
        // rowHeight={45}
        manualPagination={true}
        handlePerRowsChange={handlePerRowsChange}
        handlePageChange={handlePageChange}


        selectColumn={selectColumn}
        onSelectedRowsChange={handleRowSelection}
        selectedRows={selectedRows}
      />


      {/* <DataGrid
            dynamicClass='allowDropDown'
            mainDivClass="patientSearchDynamicClass"
            paginationDefaultPage={1}
            columns={columns}
            rows={rows}
            pagination={{
              perPage: paramModel.perPage,
              pageNo: paramModel.pageNo,
              totalCount: paramModel.totalCount,
            }}
            height="100%"
            minHeight='300px'
            maxHeight='105px'
            manualPagination={true}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
            // onRowsChange={onRowsChange}   
            selectColumn={selectColumn}
            onSelectedRowsChange={handleRowSelection}
            selectedRows={selectedRows}
            id="VisitSearchGrid"
            rowHeight={(args) =>
              args.type === "ROW" && args.row.type === "DETAIL" ? 65 : 40
            }
          /> */}
    </ >
  );
};

export default ChargesSearchGrid;
